import { ResizeableColumns } from "../resizableColumns/ResizeableColumns";

import type { ReactNode } from "react";

const MIN_DRAWER_WIDTH = 400;
const MIN_PLAYER_WIDTH = 650;

export interface WatchViewMainProps {
  children?: ReactNode;
  isDrawerOpen?: boolean;
  isDesktopLayout?: boolean;
}

export function WatchViewMain({
  children,
  isDrawerOpen,
  isDesktopLayout,
}: WatchViewMainProps) {
  return (
    <div className="WatchViewMain">
      <ResizeableColumns
        style={{ overflow: "hidden" }}
        firstColumnStyle={{ display: "flex", height: "100%" }}
        forceSingleColumn={!isDesktopLayout || !isDrawerOpen}
        minFirstColumnWidth={MIN_PLAYER_WIDTH}
        minSecondColumnWidth={MIN_DRAWER_WIDTH}
        separatorMargin={0}
        initPosition={0.9}
      >
        {children}
      </ResizeableColumns>
    </div>
  );
}
